import {
  Page,
  Layout,
  TextField,
  Card,
  BlockStack,
  InlineStack,
  Button,
  
} from '../components/admin-ui';
import { useState, useCallback } from "react";
import { useNavigate } from 'react-router-dom';

import storageUtils from "../utils/storageUtils";
import { adming_login } from "../api";

export default function Login() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const handleUserName = useCallback(
    (value) => setUserName(value),
    []
  );
  const handlePassword = useCallback(
    (value) => setPassword(value),
    []
  );

  const toLogin = async () => {
      try {
        setIsLoading(true);
        const params = {
          username: userName,
          password: password,
        };
        const response = await adming_login(params);
        if (response.status === 200) {
          handleUserName("");
          handlePassword("");
          storageUtils.set("NASadminToken", response.data);
          navigate("/")
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

  return (
    <Page>
      <Layout>
        <Card sectioned>
          <BlockStack gap="100">
            <TextField
              label="User Name"
              value={userName}
              onChange={handleUserName}
              autoComplete="off"
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={handlePassword}
              autoComplete="off"
            />
            <InlineStack align="end">
              <Button
                submit
                onClick={() => {
                  toLogin();
                }}
                loading={isLoading}
              >
                Login
              </Button>
            </InlineStack>
          </BlockStack>
        </Card>
      </Layout>
    </Page>
  );
}
